import React from "react";
import {useForm} from "react-hook-form";
import {useMutation, useQuery} from "@apollo/client";
import {ADD_TOUR_ITEM, GET_TOUR_ITEMS_LIST} from "../gql/tours-gql";
import {LoginButton} from "../../styles/Styles";
import {toast} from "react-toastify";
import styled from "styled-components";
import {InfinitySpin} from "react-loader-spinner";

const FormContainer = styled.div`
    padding: 2rem;
    max-width: 600px;
    margin: 0 auto;
`;

const FormGroup = styled.div`
    margin-bottom: 1.5rem;
`;

const Label = styled.label`
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #333;
`;

const Input = styled.input`
    width: 100%;
    padding: 0.8rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 1rem;
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: #4CAF50;
    }
`;

const ErrorMessage = styled.span`
    color: #f44336;
    font-size: 0.9rem;
    margin-top: 0.5rem;
    display: block;
`;

const FormTitle = styled.h2`
    margin-bottom: 2rem;
    color: #333;
    text-align: center;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 2rem;
`;

const ExistingLabelsList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 2rem 0;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 1rem;
`;

const ExistingLabelsTitle = styled.h3`
    color: #333;
    margin-bottom: 1rem;
    font-size: 1.1rem;
`;

const LabelItem = styled.li`
    padding: 0.5rem;
    border-bottom: 1px solid #ddd;
    color: #666;

    &:last-child {
        border-bottom: none;
    }
`;

const AddTourItemForm: React.FC = () => {
    const {data: toursItems, loading: toursLoading} = useQuery(GET_TOUR_ITEMS_LIST);
    const labels = toursItems?.getTourItemsList || [];

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    const [addTourItemMutation] = useMutation(ADD_TOUR_ITEM, {
        refetchQueries: [{ query: GET_TOUR_ITEMS_LIST }],
        onCompleted: (data) => {
            toast.success("Added successfully!");
            reset();
        }
    });

    const onSubmit = async(data: any) => {
        try {
            await addTourItemMutation({
                variables: {
                    tourItemInput: {
                        title: data.title
                    }
                }
            });
        } catch (error) {
            console.error('Error adding tour label:', error);
            toast.error('Failed to add tour label');
        }
    }

    if (toursLoading) return <InfinitySpin />;

    return (
        <FormContainer>
            <FormTitle>Add New Tour Label</FormTitle>

            <ExistingLabelsList>
                <ExistingLabelsTitle>Existing Labels:</ExistingLabelsTitle>
                {labels.map((label: any, index: number) => (
                    <LabelItem key={index}>{label.title}</LabelItem>
                ))}
            </ExistingLabelsList>

            <form onSubmit={handleSubmit(onSubmit)}>
                <FormGroup>
                    <Label htmlFor="title">Title</Label>
                    <Input
                        {...register("title", { required: true })}
                        type="text"
                        placeholder="Enter tour label title"
                    />
                    {errors.title && <ErrorMessage>This field is required</ErrorMessage>}
                </FormGroup>

                <ButtonContainer>
                    <LoginButton type="submit">Add Tour Label</LoginButton>
                </ButtonContainer>
            </form>
        </FormContainer>
    );
}

export default AddTourItemForm;
